import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CalendarEvent, CalendarMonthViewDay } from 'angular-calendar';

import { ScheduleService } from 'src/app/services/schedule.service';
import { CalendarMonthComponent } from 'src/app/components/calendar/calendar-month/calendar-month.component';

@Component({
  selector: 'app-agenda-medico-proximas',
  templateUrl: './agenda-medico-proximas.component.html',
  styleUrls: ['./agenda-medico-proximas.component.css']
})
export class AgendaMedicoProximasComponent implements OnInit {
  @Output() messageEventHour = new EventEmitter<any>();
  @Output() messageEventDay = new EventEmitter<any>();

  @ViewChild(CalendarMonthComponent) CALENDAR: CalendarMonthComponent;

  options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  options_week = { weekday: 'long' };
  options_month = { month: 'long' };

  list_hours: Array<any> = [];
  events_calendar: Array<any> = [];
  hoursDay: Array<any> = [];

  daySelected: any = {};
  dia_seleccionado = false;

  horas_calendar = true;
  horasCargadas = false;

  horasAuxiliares: any[] = [];
  horasAgrupadas: any[] = [];

  horasAgrupadasAM: any[] = [];
  horasAgrupadasPM: any[] = [];
  selectedHourTabIndex: number = 0;

  diaInicialPendiente: CalendarMonthViewDay = null;

  constructor(
    public scheduleService: ScheduleService
  ) {}

  ngOnInit(): void {
    this.getHorasBloques();
  }

  async getHorasBloques(fechaSeleccionada = null) {
   await this.scheduleService.getScheduleTimes(fechaSeleccionada)
      .then((data: any) => {
        this.hoursDay = data || [];

        if (this.diaInicialPendiente) {
          const dayPendiente = this.diaInicialPendiente;
          this.diaInicialPendiente = null;
          this.clickDayCalendar(dayPendiente);
        }
      })
      .catch((error) => {
        console.error('Error al obtener bloques de horas:', error);
        this.hoursDay = [];
      });
  }

  sendToAgendaMedico(list_hours_doc: any, dia_inicial: Date = null): void {
    this.horasCargadas = false;
    this.dia_seleccionado = false;
    this.daySelected = {};
    this.horasAuxiliares = [];
    this.horasAgrupadas = [];
    this.horasAgrupadasAM = [];
    this.horasAgrupadasPM = [];
    this.selectedHourTabIndex = 0;

    this.list_hours = list_hours_doc || [];

    const diaInicial = dia_inicial || new Date();

    this.sendToCalendar(this.list_hours, diaInicial);
  }

  sendToCalendar(eventsX: any[], dia_inicial: Date): void {
    const events_calendar: Array<CalendarEvent> = [];

    for (const eve of eventsX || []) {
      if (!eve.sch_date) continue;

      events_calendar.push({
        start: new Date(eve.sch_date.substr(0, 10).replaceAll('-', '/')),
        title: eve.sch_id
      });
    }

    if (this.CALENDAR) {
      this.CALENDAR.sendToCalendar(events_calendar, dia_inicial);
    }
  }

  clickHour(hora: any): void {
    this.messageEventHour.emit({
      day: this.daySelected,
      hour: hora
    });
  }

  clickMonthCalendar(data: any): void {
    // Si después necesitas recargar agenda por mes, se puede hacer desde aquí.
  }

  async clickDayCalendar(dayCalendar: CalendarMonthViewDay) {
    if (!this.hoursDay || this.hoursDay.length === 0) {
      this.diaInicialPendiente = dayCalendar;
      return;
    }

    this.horasCargadas = false;
    this.dia_seleccionado = true;
    this.daySelected = {};
    this.horasAuxiliares = [];
    this.horasAgrupadas = [];
    this.horasAgrupadasAM = [];
    this.horasAgrupadasPM = [];
    this.selectedHourTabIndex = 0;

    this.daySelected.date = dayCalendar.date;
    this.daySelected.dateInt = this.toDateInt(this.daySelected.date);
    this.daySelected.dateString = this.daySelected.date.toLocaleString('es-US', this.options);
    this.daySelected.dayTitle =
      this.daySelected.date.toLocaleString('es-US', this.options_week) +
      ' ' +
      this.daySelected.date.getDate() +
      ' de ' +
      this.daySelected.date.toLocaleString('es-US', this.options_month);

      await this.getHorasBloques(this.daySelected.date);


    const horasDelDia = this.getHorasDelDia(this.daySelected.dateInt);

    if (horasDelDia.length === 0) {
      this.daySelected.available = false;
      this.daySelected.hours_available = [];
      this.horasCargadas = true;
      this.emitDaySelected();
      return;
    }

    this.daySelected.available = true;
    this.daySelected.sch_id = horasDelDia[0].sch_id;
    this.daySelected.hours_available = this.normalizarHorasDisponibles(horasDelDia);

    this.horasAuxiliares = this.construirBloquesDisponibles(this.daySelected.hours_available);
    this.horasAgrupadas = this.groupHoursByBaseHour(this.horasAuxiliares);

    this.separarHorasAmPm();

    if (this.horasAgrupadas.length === 0) {
      this.daySelected.available = false;
      this.horasAgrupadasAM = [];
      this.horasAgrupadasPM = [];
      this.selectedHourTabIndex = 0;
    } else {
      this.seleccionarTabInicial();
    }

    this.emitDaySelected();
    this.horasCargadas = true;
  }

  private separarHorasAmPm(): void {
    const horasAM = this.horasAuxiliares.filter(hour => this.getHourNumber(hour.from) < 12);
    const horasPM = this.horasAuxiliares.filter(hour => this.getHourNumber(hour.from) >= 12);

    this.horasAgrupadasAM = this.groupHoursByBaseHour(horasAM);
    this.horasAgrupadasPM = this.groupHoursByBaseHour(horasPM);
  }

  private seleccionarTabInicial(): void {
    const hoyInt = this.toDateInt(new Date());
    const esFechaFutura = this.daySelected?.dateInt > hoyInt;

    if (esFechaFutura) {
      this.selectedHourTabIndex = 0;
      return;
    }

    const existenHorasAM = this.horasAgrupadasAM?.some(group => group.hours?.length > 0);

    this.selectedHourTabIndex = existenHorasAM ? 0 : 1;
  }

  private getHourNumber(hour: string): number {
    if (!hour) return 0;
    return Number(hour.substring(0, 2));
  }

  private getHorasDelDia(dateInt: number): any[] {
    return (this.list_hours || []).filter((hour) => {
      if (!hour.sch_date) return false;
      return this.getDateIntFromSchDate(hour.sch_date) === dateInt;
    });
  }

  private normalizarHorasDisponibles(horasDelDia: any[]): any[] {
    const hoursX = [];

    for (const hour of horasDelDia) {
      if (hour.hours) {
        for (const xx of hour.hours) {
          hoursX.push({
            sch_hou_id: xx.id,
            sch_hou_from: xx.from,
            sch_hou_to: xx.to,
            sch_sta_id: xx.sta_id,
            is_ondemand: xx.is_ondemand || false
          });
        }
      } else {
        hoursX.push({
          sch_hou_id: hour.sch_hou_id,
          sch_hou_from: hour.sch_hou_from,
          sch_hou_to: hour.sch_hou_to,
          sch_sta_id: hour.sch_sta_id,
          is_ondemand: hour.is_ondemand || false
        });
      }
    }

    return hoursX;
  }

  private construirBloquesDisponibles(hoursAvailable: any[]): any[] {
    const bloques = [];

    for (const blockOriginal of this.hoursDay || []) {
      const block = { ...blockOriginal };

      block.available = false;
      block.sch_hou_id = null;
      block.existe = false;
      block.hour_number = Number(block.from.replaceAll(':', ''));

      for (const hour of hoursAvailable) {
        block.existe = hour.sch_sta_id ? block.existe : true;

        if (block.from === hour.sch_hou_from) {
          block.available = hour.sch_sta_id ? hour.sch_sta_id === 21 : true;
          block.existe = true;
          block.sta_id = hour.sch_sta_id;
          block.is_ondemand = !!hour.is_ondemand;
          block.sch_hou_id = hour.sch_hou_id;

          bloques.push({ ...block });
        }
      }
    }

    return bloques;
  }

  private emitDaySelected(): void {
    this.messageEventDay.emit({
      date: this.daySelected.date,
      dateInt: this.daySelected.dateInt,
      dateString: this.daySelected.dateString,
      dayTitle: this.daySelected.dayTitle
    });
  }

  private toDateInt(date: Date): number {
    return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
  }

  private getDateIntFromSchDate(schDate: string): number {
    const cleanDate = schDate.substr(0, 10);
    const parts = cleanDate.split('-');

    const year = Number(parts[0]);
    const month = Number(parts[1]);
    const day = Number(parts[2]);

    return year * 10000 + month * 100 + day;
  }

  groupHoursByBaseHour(hours: any[]): any[] {
    const grouped = {};

    hours.forEach((itemHour) => {
      const block = itemHour.from.substring(0, 2);

      if (!grouped[block]) {
        grouped[block] = [];
      }

      grouped[block].push(itemHour);
    });

    return Object.keys(grouped)
      .sort()
      .map(key => ({
        block: key,
        hours: grouped[key].sort((a, b) => a.hour_number - b.hour_number)
      }));
  }
}